import {combineReducers} from 'redux';
import {userReducer} from './userReducer';

const reducers = combineReducers({
    redux: userReducer,
});

export default reducers;